import { render, staticRenderFns } from "./TemplateVerification.vue?vue&type=template&id=5e4f66ec&scoped=true"
import script from "./TemplateVerification.vue?vue&type=script&lang=js"
export * from "./TemplateVerification.vue?vue&type=script&lang=js"
import style0 from "./TemplateVerification.vue?vue&type=style&index=0&id=5e4f66ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f66ec",
  null
  
)

export default component.exports